import React, { useState } from "react";

export default function DeliveryForm() {
  const [formData, setFormData] = useState({
    order_id: "",
    status: "",
    delivered_at: "",
  });
  const [errors, setErrors] = useState({});

  const statuses = ["Pending", "In Progress", "Delivered", "Cancelled"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateInputs = () => {
    const errors = {};
    if (!formData.order_id) errors.order_id = "Order ID is required";
    if (!formData.status) errors.status = "Status is required";
    if (!formData.delivered_at) errors.delivered_at = "Delivery date is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (validateInputs()) {
      console.log("Delivery submitted:", formData);
      // Submission logic here
    }
  };

  return (
    <div className="bg-white shadow-lg rounded-lg p-6 max-w-4xl mx-auto">
      <div className="flex flex-col">
        <div className="flex flex-row items-center justify-between p-4 bg-gray-200 rounded-t-lg">
          <h3 className="font-semibold text-lg text-gray-700">New Delivery</h3>
          <button
            className="text-lightBlue-500 bg-transparent border border-solid border-lightBlue-500 hover:bg-lightBlue-500 hover:text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
        <form className="p-4 space-y-6">
          {/* Order ID */}
          <div className="mb-3">
            <input
              type="text"
              name="order_id"
              placeholder="Order ID"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.order_id}
              onChange={handleInputChange}
            />
            {errors.order_id && <p className="text-red-500 text-xs mt-1">{errors.order_id}</p>}
          </div>

          {/* Status */}
          <div className="mb-3">
            <select
              name="status"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.status}
              onChange={handleInputChange}
            >
              <option value="">Select Status</option>
              {statuses.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
            {errors.status && <p className="text-red-500 text-xs mt-1">{errors.status}</p>}
          </div>

          {/* Delivered At */}
          <div className="mb-3">
            <input
              type="datetime-local"
              name="delivered_at"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.delivered_at}
              onChange={handleInputChange}
            />
            {errors.delivered_at && <p className="text-red-500 text-xs mt-1">{errors.delivered_at}</p>}
          </div>
        </form>
      </div>
    </div>
  );
}
